/*
* Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
* This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
* The receipt or possession of this program does not convey any rights to use, reproduce or disclose
* its contents in whole or in part, without the specific written consent of Inovalon, Inc.
* Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
* is a violation of the copyright laws and may subject you to criminal prosecution.
*/
import { observer } from 'mobx-react'
import React, { Fragment } from 'react'
import { ICoverageDiscoveryResponseStateManager, IBaseSection, IImmunizationInsurance, IImmunizationHistory } from '../../../../services/CoverageDiscoveryResponseStateManager/contracts'
import { ImmunizationEligibilityComponent } from '../../Medicare/ImmunizationEligibility/ImmunizationEligibility'
import { ImmunizationEventComponent } from '../../Medicare/ImmunizationEvent/ImmunizationEvent'
import { DeductiblesComponent } from '../../Medicare/Deductibles/Deductibles'
import { CoInsurance } from '../../Medicare/CoInsurance/CoInsurance'
import { Collapse, CardBody, Card, CardHeader } from 'reactstrap'
interface IImmunizationSummaryProps {
	CoverageDiscoveryResponseStateManager: ICoverageDiscoveryResponseStateManager
}

interface IImmunizationSummaryState {
	IsPageLoading: boolean
	collapse: number
}
@observer
export class ImmunizationSummaryComponent extends React.Component<IImmunizationSummaryProps, IImmunizationSummaryState> {
	toggle(e): void {
		const event = e.target.dataset.event
		this.setState({ collapse: this.state.collapse === Number(event) ? 0 : Number(event) })
	}
	constructor(props: Readonly<IImmunizationSummaryProps>) {
		super(props)
		this.state = {
			IsPageLoading: true,
			collapse: 0,
		}
		this.toggle = this.toggle.bind(this)
	}
	componentDidMount(): void {
		this.setIsPageLoadState(false)
	}
	setIsPageLoadState(val: boolean) {
		this.setState({
			IsPageLoading: val,
		})
	}
	render(): React.ReactNode {
		const { collapse } = this.state
		const section = this.props.CoverageDiscoveryResponseStateManager.selectedCovid19ImmunizationSection
		if (this.props.CoverageDiscoveryResponseStateManager.selectedCovid19ImmunizationSection !== undefined) {
			return (
				<div className="accordion-group service-coverage">
					<div id={section.id} className="section" data-loadorder={section.loadOrder} data-index={section.summary.index}>
						<Card style={{ marginBottom: '1rem' }} className="card" key={section.displayOrder}>
							<CardHeader onClick={this.toggle} data-event={section.displayOrder} className="service-coverage accordion-heading whiteText">
								{section.summary.title}
							</CardHeader>
							<Collapse isOpen={collapse === section.displayOrder}>
								<CardBody className="card-body">
									<div className="cdResponsePage">
										<table className="service-types-table">
											<tbody>
												<tr className="summaryDisplaying">
													<td colSpan={4}>
														Displaying {section.summary.selectedSections.length} of {section.summary.sections.length} sections
													</td>
												</tr>
											</tbody>
											<tbody className="summaryBody">
												<tr className="summarySection">
													<td colSpan={2}>
														<h4>Immunization Eligibility</h4>
													</td>
													<td className="summaryHide" colSpan={2}></td>
												</tr>
											</tbody>
											<tbody className="summaryBody">{this.renderImmunizationEligibilityInformation(section)}</tbody>
											<tbody className="summaryBody">
												<tr className="summarySection">
													<td colSpan={2}>
														<h4>Immunization History</h4>
													</td>
													<td className="summaryHide" colSpan={2}></td>
												</tr>
											</tbody>
											<tbody className="summaryBody">{this.renderImmunizationHistory(section)}</tbody>
										</table>
									</div>
								</CardBody>
							</Collapse>
						</Card>
					</div>
				</div>
			)
		} else return <></>
	}

	renderImmunizationEligibilityInformation(section: IBaseSection) {
		if (section.summary.immunizationEligibility !== null && section.summary.immunizationEligibility !== undefined) {
			return <Fragment>{this.renderImmunizationEligibility(section)}</Fragment>
		} else {
			return (
				<tr className="no-info">
					<td colSpan={4}>No immunization eligibility information available</td>
				</tr>
			)
		}
	}

	renderImmunizationInsurance(immunizationInsurance: IImmunizationInsurance) {
		if (immunizationInsurance !== null && immunizationInsurance !== undefined)
			return (
				<Fragment>
					{immunizationInsurance.deductibles && <DeductiblesComponent data={immunizationInsurance.deductibles} />}
					<CoInsurance data={immunizationInsurance} />
				</Fragment>
			)
	}

	renderImmunizationHistory(section: IBaseSection) {
		if (section.summary.immunizationHistory && section.summary.immunizationHistory.length > 0) {
			return section.summary.immunizationHistory && section.summary.immunizationHistory.map((x: IImmunizationHistory, index: number) => <ImmunizationEventComponent data={x} key={index}></ImmunizationEventComponent>)
		} else {
			return (
				<tr className="no-info">
					<td colSpan={4}>No immunization history information available</td>
				</tr>
			)
		}
	}

	renderImmunizationEligibility(section: IBaseSection) {
		return (
			<Fragment>
				{section.summary.immunizationEligibility && <ImmunizationEligibilityComponent data={section.summary.immunizationEligibility} />}
				{section.summary.immunizationInsurance && this.renderImmunizationInsurance(section.summary.immunizationInsurance)}
			</Fragment>
		)
	}
}
